import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import './App.scss';
import Loading from './components/Loading'
//import * as twilio from 'twilio';
import IdleTimer from 'react-idle-timer';
import {userLogedinOrNot } from "./lib/commonFunctions";
const loading = () => <Loading loadingStatus={true} />;

// Containers
const DefaultLayout = React.lazy(() => import('./containers/DefaultLayout'));

// Pages
const APISTesting = React.lazy(() => import('./views/Pages/APISTesting'));
const Login = React.lazy(() => import('./views/Pages/Login'));
const Chat = React.lazy(() => import('./views/Pages/Login/ChatApp'));
const ForgotPassword = React.lazy(() => import('./views/Pages/ForgotPassword/ForgotPassword'));
const CofirmForgotPassword = React.lazy(() => import('./views/Pages/ForgotPassword/CofirmForgotPassword'));
const SetNewPassword = React.lazy(() => import('./views/Pages/Login/SetNewPassword'));
const Page404 = React.lazy(() => import('./views/Pages/Page404'));
const Page500 = React.lazy(() => import('./views/Pages/Page500'));

class App extends Component {
  async componentDidMount() {
    const user = await userLogedinOrNot();
    if(user){
      //console.log("User Logged in");
    } else {
      //console.log("User Not Logged in");
      localStorage.clear();
    }
  }

  render() {
    return (
      <>
        <IdleTimer
          ref={ref => { this.idleTimer = ref }}
          element={document}
          onActive={this.onActive}
          onIdle={this.onIdle}
          onAction={this.onAction}
          debounce={250}
          timeout={1000} />
        <BrowserRouter>
            <React.Suspense fallback={loading()}>
              <Switch>
                <Route exact path="/apisTest" name="APIs Testing" render={props => <APISTesting {...props}/>} />
                <Route exact path="/login" name="Login Page" render={props => <Login {...props}/>} />
                <Route exact path="/chat" name="Chat Page" render={props => <Chat {...props}/>} />
                <Route exact path="/forgot_password" name="Forgot Page" render={props => <ForgotPassword {...props}/>} />
                <Route exact path="/confirm_forgot_password" name="Confirm Forgot Page" render={props => <CofirmForgotPassword {...props}/>} />
                <Route exact path="/set_new_password" name="Set new password" render={props => <SetNewPassword {...props}/>} />
                <Route exact path="/404" name="Page 404" render={props => <Page404 {...props}/>} />
                <Route exact path="/500" name="Page 500" render={props => <Page500 {...props}/>} />
                <Route path="/" name="Home" render={props => <DefaultLayout {...props}/>} />
              </Switch>
            </React.Suspense>
        </BrowserRouter>
      </>
    );
  }
}

export default App;
